import { useEffect, useState } from "react";

import { MobileSelectionListItem } from "common/components/MobileSelectionList";
import MobileSelectionList from "common/components/MobileSelectionList/MobileSelectionList";
import Pagination from "common/components/ui/Pagination";
import type { WorkspaceAccount } from "common/types";

import { MOBILE_TAGS } from "../../constants";
import AccountName from "../AccountName";
import AccountProfileImage from "../AccountProfileImage";

const PAGE_SIZE = 10;

export default function MobileList({
  accounts,
  selectedAccounts,
  setSelectedAccounts,
}: {
  accounts: WorkspaceAccount[];
  selectedAccounts: WorkspaceAccount[];
  setSelectedAccounts: (selectedAccounts: WorkspaceAccount[]) => void;
}) {
  const [page, setPage] = useState(0);

  useEffect(() => {
    setPage(0);
  }, [accounts]);

  const pageItems = accounts.slice(
    page * PAGE_SIZE,
    page * PAGE_SIZE + PAGE_SIZE,
  );
  return (
    <>
      <MobileSelectionList
        data={pageItems}
        selection={selectedAccounts}
        onSelectionChange={(newSelection) => {
          if (newSelection === "all") {
            setSelectedAccounts(accounts);
          } else {
            setSelectedAccounts(newSelection);
          }
        }}
        totalDataCount={accounts.length}
        allTags={MOBILE_TAGS}
      >
        {(account, listItemProps) => (
          <MobileSelectionListItem {...listItemProps} to={account.id}>
            <AccountProfileImage account={account} size="sm" />
            <div className="flex flex-col flex-1">
              <AccountName account={account} className="text-xs-bold" />
              <p className="text-button-xxs text-black-500 line-clamp-1 break-all text-left">
                {account.occupation}
              </p>
            </div>
          </MobileSelectionListItem>
        )}
      </MobileSelectionList>

      <Pagination
        size="sm"
        pageSize={PAGE_SIZE}
        itemCount={accounts.length}
        setPage={setPage}
        selectedIndex={page}
        isLastPageHidden={false}
      />
    </>
  );
}
